import app from './app';
import { ORDER_SERVICE_URL, REPORTS_SERVICE_URL, REPORT_SERVICE_URL } from './../../libs/constants';
import { saveAs } from 'file-saver';

const getReports = (userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const response = await api.post(REPORTS_SERVICE_URL + 'list/' + userId);//change to get and end point

        dispatch({ type: "SET_REPORTS_DATA", data: response.data.reportList });
        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getAllReports = (searchConfig, userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        console.log('Search config :' + JSON.stringify(searchConfig));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getAllReports" } };

        const response = await api.post("order" + REPORT_SERVICE_URL + "list/" + userId, searchConfig, headerConfig);

        dispatch({ type: "SET_DRS_REPORTS_DATA", payload: response.data });
        dispatch(app.setLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

//post for download
const getReportData = (requestObj) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const response = await api.post(ORDER_SERVICE_URL + '/codreport', requestObj);//change to get and end point
        dispatch({
            type: "SET_REPORT_DATA",
            data: response.data
        });
        dispatch(app.setLoading(false));

    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_REPORT_DATA",
            data: 'REQUEST-FAILED'
        });
        dispatch(app.setAppModal({ type: "error", messageId: "reports_error", content: null, toBeHidden: false }));
        console.log(error);
    }
};

const downloadReports = (userId, orderId, reportTypes) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf",
            "DRS-Fetch-Type": "downloadReport"
        },
        responseType: "blob"
    };

    for (var i = 0; i < reportTypes.length; i++) {
        if (reportTypes[i] === "afr") {
            await api.post('order' + REPORT_SERVICE_URL + 'download/' + userId + '/' + orderId + '?reportType=afr', null, downloadConfig).then(response => {
                saveAs(new Blob([response.data]), orderId + "_Audit&FinancialReport.xlsx");
                window.dataLayer.push({
                    event: 'e_document',
                    documentAction: 'download',
                    documentID: `${orderId}_Audit&FinancialReport.xlsx`,
                    documentType: 'xlsx'
                });
            }).catch(error => {
                console.log('Error in downloading Audit&Financial report :', error);
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            });
        }
        else if (reportTypes[i] === "sbr") {
            await api.post('order' + REPORT_SERVICE_URL + 'download/' + userId + '/' + orderId + '?reportType=sbr', null, downloadConfig).then(response => {
                saveAs(new Blob([response.data]), orderId + "_SustainabilityReport.pdf");
                window.dataLayer.push({
                    event: 'e_document',
                    documentAction: 'download',
                    documentID: `${orderId}_SustainabilityReport.xlsx`,
                    documentType: 'xlsx'
                });
            }).catch(error => {
                console.log('Error in downloading SustainabilityBenefit report :', error);
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            });
        }
        else if (reportTypes[i] === "dsr") {
            await api.post('order' + REPORT_SERVICE_URL + 'download/' + userId + '/' + orderId + '?reportType=dsr', null, downloadConfig).then(response => {
                saveAs(new Blob([response.data]), orderId + "_DataSanitizationReport.pdf");
                window.dataLayer.push({
                    event: 'e_document',
                    documentAction: 'download',
                    documentID: `${orderId}_DataSanitizationReport.xlsx`,
                    documentType: 'xlsx'
                });
            }).catch(error => {
                console.log('Error in downloading DataSanitization report :', error);
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            });
        }
        else if (reportTypes[i] === "vendorafr") {
            await api.post(ORDER_SERVICE_URL + '/download/vendorafr/' + userId + "/" + orderId, null, downloadConfig).then(response => {
                saveAs(new Blob([response.data]), orderId + "_VendorAudit&FinancialReport.xlsx");
                window.dataLayer.push({
                    event: 'e_document',
                    documentAction: 'download',
                    documentID: `${orderId}_VendorAudit&FinancialReport.xlsx`,
                    documentType: 'xlsx'
                });
            }).catch(error => {
                console.log('Error in downloading VendorAudit&Financial report :', error);
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            });
        }
    }
};

const downloadVendorReports = (userId, orderId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf",
            "DRS-Fetch-Type": "downloadVendorReport"
        },
        responseType: "blob"
    };
    await api.post(ORDER_SERVICE_URL + '/download/vendorafr/' + userId + "/" + orderId, null, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), orderId + "_Audit&FinancialReport.xlsx");
        })
        .catch(error => {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const downloadHPRevitalizeReport = (userId, orderId, fileName) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf",
            "DRS-Fetch-Type": "downloadVendorReport"
        },
        responseType: "blob"
    };
    if (fileName) {
        await api.post(ORDER_SERVICE_URL + '/download/ctUploadafrAfterUpload/' + userId + "/" + orderId, null, downloadConfig)
            .then(response => {
                saveAs(new Blob([response.data]), fileName);
            })
            .catch(error => {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            });
    } else {
        await api.post(ORDER_SERVICE_URL + '/download/ctafr/' + userId + "/" + orderId, null, downloadConfig)
            .then(response => {
                saveAs(new Blob([response.data]), orderId + "_HP_Revitalize_Report.xlsx");
            })
            .catch(error => {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            });
    }

};

//POST
const saveReport = (userId, requestData, CB) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const response = await api.post(REPORTS_SERVICE_URL + 'save/' + userId, requestData);//change to post and end point
        dispatch(app.setLoading(false));
        response && CB();
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        console.log(error);
    }
};

//PUT
const updateSavedReport = (reportId, requestData, CB) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const response = await api.post(REPORTS_SERVICE_URL + 'edit/' + reportId, requestData);//change to post and end point
        dispatch(app.setLoading(false));
        response && CB();
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        console.log(error);
    }
};

//DELETE
const deleteSavedReport = (reportId, CB) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const response = await api.post(REPORTS_SERVICE_URL + 'delete/' + reportId);//change to DELETE and end point
        response && CB();
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        console.log(error);
    }
};

//to initalize with defaults for next requests to work properly
const resetReportData = () => async (dispatch, getState, api) => {
    dispatch({
        type: "SET_REPORT_DATA",
        data: false
    });
};

const setCheckBoxSelectionForSpecificReport = (value, reportType, orderId) => {
    return {
        type: "SET_CHECKBOX_SELECTION_FOR_SPECIFIC_REPORT",
        value,
        reportType,
        orderId
    }
};

const resetCheckBoxSelectionForSpecificReport = (value, reportType, orderId) => {
    return {
        type: "RESET_CHECKBOX_SELECTION_FOR_SPECIFIC_REPORT"
    }
};

const reportActions = {
    getReports: getReports,
    getReportData: getReportData,
    saveReport: saveReport,
    updateSavedReport: updateSavedReport,
    deleteSavedReport: deleteSavedReport,
    resetReportData: resetReportData,
    getAllReports: getAllReports,
    downloadReports: downloadReports,
    downloadVendorReports: downloadVendorReports,
    downloadHPRevitalizeReport: downloadHPRevitalizeReport,
    setCheckBoxSelectionForSpecificReport: setCheckBoxSelectionForSpecificReport,
    resetCheckBoxSelectionForSpecificReport: resetCheckBoxSelectionForSpecificReport
}

export default reportActions;